import buildoutLogo from 'assets/images/logos/buildout-logo-horizontal-blue.svg';
import campaignBreezeLogo from 'assets/images/logos/campaign-breeze.png';
import constantContactLogo from 'assets/images/logos/constant-contact.png';
import icontactLogo from 'assets/images/logos/icontact.png';
import mailchimpLogo from 'assets/images/logos/mailchimp.png';
import youmanLogo from 'assets/images/logos/youman-logo.png';

import type { FieldKey, ProviderDisplay, ProviderEnum } from './types';

export const PROVIDER_ORDER: ProviderEnum[] = [
  'Constant Contact',
  'MailChimp',
  'IContact',
  'Youman',
  'Campaign Breeze',
  'Buildout',
];

export const PROVIDER_DISPLAY: Record<ProviderEnum, ProviderDisplay> = {
  'Constant Contact': {
    label: 'Constant Contact',
    logo: constantContactLogo,
    signUpUrl: 'https://go.constantcontact.com/signup.jsp?pn=buildout',
    flow: 'oauth',
    fields: [],
    showPromotion: true,
  },
  MailChimp: {
    label: 'MailChimp',
    logo: mailchimpLogo,
    signUpUrl: 'https://mailchimp.com',
    flow: 'credentials',
    fields: ['apiKey'],
  },
  IContact: {
    label: 'iContact',
    logo: icontactLogo,
    signUpUrl: 'https://www.icontact.com',
    flow: 'credentials',
    fields: ['userName', 'password'],
    showIContactInstructions: true,
  },
  Youman: {
    label: 'Youman',
    logo: youmanLogo,
    signUpUrl: 'https://mail.rms-media.net/signin',
    flow: 'credentials',
    fields: ['userName', 'password'],
    fieldLabels: { userName: 'Email' },
  },
  'Campaign Breeze': {
    label: 'Campaign Breeze',
    logo: campaignBreezeLogo,
    style: { backgroundColor: '#f7a87d' },
    flow: 'credentials',
    fields: ['userName', 'password', 'apiKey'],
  },
  Buildout: {
    label: 'Buildout',
    logo: buildoutLogo,
    flow: 'buildout',
    fields: [],
  },
};

export const FIELD_LABELS: Record<FieldKey, string> = {
  userName: 'Username',
  password: 'Password',
  apiKey: 'API Key',
};
